/* eslint-disable max-len */

import React from "react";
import PropTypes from "prop-types";

class LogoLeo extends React.Component {
  render() {
    const styleSvg = {
      marginTop: 3,
      fill: this.props.fill ? this.props.fill : null
    };
    const styleFillRule = {
      fillRule: "evenodd"
    };

    return (
      <svg
        id="MalondIcon"
        width={this.props.width}
        height={this.props.height}
        style={{ ...styleSvg }}
        data-name="MalondIcon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 473 415"
      >
        <g id="Leo">
          <path
            id="MalondIconShape"
            style={styleFillRule}
            data-name="MalondIconShape"
            d="M329,353l9,11,28-9,6-28h50s30-4.5,34-55c2.5-1.5,12.5-16,10-51,18.5-27.5,2-28.5-43-61,0.5,1.5-42-23-42-23l-3-24-15-7s-63.5-46.5-65-48c-8-39-50-80.5-153-45-0.5,1.5-11,11-11,11l-28,4L89,60l1,15s-7,24.5,2,40c0,1-14,11-14,11l3,20L63,197l3,12,52-33L89,224l5,33,31-43h16L120,323l31,52s23.5,27.5,54,34c0.5,0,35-3,35-3l-1-4s-118,11.5-91-112c10.5,33,66,77,66,77s16.575,12.952,30.34,26.166A223.549,223.549,0,0,1,264,415l14-3-70-87s-105.5-39.5-26-171c-0.5.5,17-19.5,17-20-16,131.5,12,173,12,173l6-99,22,94,28,35-1,21,39,48,12-2,10-14s-75-90.5-71-111c53,51,86,59,86,59l17-12-5,19M114,166L95,156,84,181Zm39,3,14-15-14-9v24Zm-2-58,43,14,14-15S176.4,29,104,75c-23.4,35.4,42.6,103.4,44,102-4-12.6-45.6-92.8-12-105,24.4,10,46,18,46,18v4l-31,2v15Zm53-29,35-3L222,92ZM121,46c0.5,0,0-8,0-8l89,5c29.75,6.75,38.25,26.25,37,26C232.25,68.25,194,52.25,121,46Zm27-23s44-8.5,75-8c24.75,0.75,41.5-1.75,56,44C244.25,36.75,148,23,148,23Zm75,106c-3,24.667,68,118,68,118s-85.833-54.167-81-90A132.425,132.425,0,0,1,223,129ZM328,249l-2-20s-68.5-54.5-68-55c-0.75-23-10.25-48-11-61,0.25-16.25,4.25-27.75,14-40,0.25,0,43,5,43,5l66,45v16l-9-14,7,18s90.5,51.25,94,62c-0.25.5-5,9-5,9l-10-10-8,6-24-12,7,17,5,6s11.75-3,14,0c0.25-.5-4,5-4,5l4,5,12-3s6.75,31-7,35c1.25,0.5-1-20-1-20l-9,18-77,12,1,13h14a12.824,12.824,0,0,1,6-6s39-13,60-12c0,0.25,1.5,19.25,2,19-4,13.5-22,27-22,27l-60-1s-22,16.5-23,17c-18.25-25-42.25-37-37-85C300.75,245,328,249,328,249Z"
            className="malond-icon-leo"
          />
          <g id="Add">
            <path
              d="M348,146l6-12-24-20,10,20-10,8H320l-15,10,21-8,21-2"
              className="malond-icon-leo"
            />
            <path
              d="M308,152l36-3,1,6,23,13s-37-9.667-46-8"
              className="malond-icon-leo"
            />
            <path
              d="M72,69s-55.667,44.667-55,45c-6.333,25,4,77,4,77l41-70H44s33-15,34-15c-4-24,2-31,2-31Z"
              className="malond-icon-leo"
            />
            <path d="M92,203L57,228l-4,67,15-59" className="malond-icon-leo" />
            <path
              d="M59,181L32,208S-0.667,267.667,0,268c6,17.667,14.333,62,39,77,1.333,0.667,8-115,8-115L25,258l25-48V199Z"
              className="malond-icon-leo"
            />
            <path
              d="M108,254L67,300l4,58,26,21,48,25-42-75L92,350Z"
              className="malond-icon-leo"
            />
          </g>
        </g>
      </svg>
    );
  }
}

LogoLeo.defaultProps = {
  width: 48,
  height: 43,
  fill: false
};

LogoLeo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.oneOf([false, PropTypes.string])
};

export default LogoLeo;
